import axios from 'axios';
import { scanForUnsafeInput } from './sanitize';

export const configureAxiosSanitizer = () => {
  axios.interceptors.request.use(
    (config) => {
      try {
        if (config.data) {
          scanForUnsafeInput(config.data, 'data');
        }
        if (config.params) {
          if (
            typeof URLSearchParams !== 'undefined' &&
            config.params instanceof URLSearchParams
          ) {
            for (const [key, value] of config.params.entries()) {
              scanForUnsafeInput(value, `params.${key}`);
            }
          } else {
            scanForUnsafeInput(config.params, 'params');
          }
        }
      } catch (err) {
        return Promise.reject(err);
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};
